import { Route, Routes, useLocation } from "react-router";
import { AnimatePresence } from "framer-motion";
import React, { Suspense, useEffect } from "react";
const Home = React.lazy(() => import("../pages/home/Home"));
const ServiceDetails = React.lazy(() => import("../pages/service/ServiceDetails"));
const NotFound = React.lazy(() => import("../pages/notFound/NotFound"));
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import PageLoader from "../components/PageLoader/PageLoader";
import { trackPageView } from "../utils/analytics";

const RoutesStack = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname, document.title);
    }, [location.pathname]);

    return (
        <>
            <ScrollToTop />
            <AnimatePresence>
                <Suspense fallback={<PageLoader />}>
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<Home />} />
                        <Route path="/service/:id" element={<ServiceDetails />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
            </AnimatePresence>
        </>
    );
};

export default RoutesStack;